// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZJY7","select":"styles_select__2q2nP"};